import React, { useState, useEffect } from "react";
import Header from "../Components/Header";
import SubHeader from "../Components/SubHeader";
import {
  Box,
  Grid,
  TextField,
  Button,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { styled } from "@mui/system";
import { Backdrop, CircularProgress } from "@mui/material";
import apiClient from "../utlis/apiClient";

const StyledTextField = styled(TextField)({
  "& .MuiInputBase-input::placeholder": {
    fontSize: "10px",
  },
});

const AddMaterials = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    MaterialName: "",
    Grade: "",
    Dimension: "",
    MaterialId: "",
    Quantity: "",
    Comments: "",
    workOrderId: "-",
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevState) => {
      const updatedData = { ...prevState, [name]: value };

      // Calculate the MaterialId if necessary fields change
      if (name === 'MaterialName' || name === 'Grade' || name === 'Dimension') {
        const materialId = `${updatedData.MaterialName}${updatedData.Grade}-${updatedData.Dimension}`;
        updatedData.MaterialId = materialId;
      }

      return updatedData;
    });
  };

  const validateFormData = () => {
    // Check if any key attribute is empty
    if (!formData.MaterialName || !formData.Grade || !formData.Dimension || !formData.MaterialId) {
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent default form submission

    if (!validateFormData()) {
      alert("Please fill in all required fields.");
      return;
    }

    setLoading(true); // Start loading

    try {
      const response = await apiClient.post(
        `/api/product/create-product`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log(response.data, ": the Product insert");

      if (response.data.result && response.data.result.success) {
        console.log("Material created successfully:", response.data.result.message);
        alert("Material inserted successfully");

        setFormData({
          MaterialName: "",
          Grade: "",
          Dimension: "",
          MaterialId: "",
          Quantity: "",
          Comments: "",
        });

        window.location.reload();
      } else {
        console.error("Error creating material:", response.data.result.message || "Unknown error");
        alert("Unable to insert the material");
      }
    } catch (error) {
      console.error("Network error:", error);
      alert("There was a network error, please try again.");
    } finally {
      setLoading(false); // End loading
    }
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <Header />
      <SubHeader />

      <Grid container sx={{ flexGrow: 1, marginTop: "-80px", padding: 0 }} spacing={6}>
        <Grid item xs={12} md={2}>
          <Box sx={{
            height: "calc(100vh - 112px)",
            backgroundColor: "white",
            borderRadius: "10px",
            marginLeft: "15px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }} />
        </Grid>

        <Grid item xs={12} md={9}>
          <Box sx={{
            height: "calc(100vh - 112px)",
            backgroundColor: "white",
            padding: 2,
            borderRadius: "10px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            marginLeft: "-60px",
          }}>
            <Typography variant="h6" gutterBottom>
              Material
            </Typography>
            <form noValidate autoComplete="off" onSubmit={handleSubmit}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={2}>
                  <FormControl variant="standard" fullWidth>
                    <InputLabel id="material-label" shrink>
                      Material Name
                    </InputLabel>
                    <Select
                      id="MaterialName"
                      name="MaterialName"
                      label="Material Name"
                      value={formData.MaterialName}
                      onChange={handleChange}
                      labelId="material-label"
                    >
                      <MenuItem value="Aluminum">Aluminum</MenuItem>
                      <MenuItem value="Copper">Copper</MenuItem>
                      <MenuItem value="EN">EN Series</MenuItem>
                      <MenuItem value="SS">SS Series</MenuItem>
                      <MenuItem value="Brass">Brass</MenuItem>
                      <MenuItem value="MS">MS</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={2}>
                  <StyledTextField
                    id="Grade"
                    name="Grade"
                    label="Grade"
                    value={formData.Grade}
                    type="text"
                    onChange={handleChange}
                    variant="standard"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={2}>
                  <StyledTextField
                    id="Dimension"
                    name="Dimension"
                    label="Dimension"
                    type="text"
                    value={formData.Dimension}
                    onChange={handleChange}
                    variant="standard"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={2}>
                  <TextField
                    id="MaterialId"
                    name="MaterialId"
                    label="MaterialId"
                    variant="standard"
                    value={formData.MaterialId}
                    onChange={handleChange}
                    disabled
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={2}>
                  <TextField
                    name="Quantity"
                    label="Quantity"
                    variant="standard"
                    type="number"
                    value={formData.Quantity}
                    onChange={handleChange}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Comments"
                    name="Comments"
                    variant="outlined"
                    value={formData.Comments}
                    onChange={handleChange}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    multiline
                    rows={2}
                  />
                </Grid>

                <Grid item xs={12} sm={3}>
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    fullWidth
                  >
                    Submit
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Box>
        </Grid>
      </Grid>
      <Backdrop
        open={loading}
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, color: "#fff" }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
};

export default AddMaterials;
